import './HeaderMobile.less';
import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import { useGetNamespaceQuery } from '@redux/api/adminApi';
import { setRightMenuOpen } from '@redux/slices/global';
import { IconMobMenuBurgerClose24 } from '@sberlab/core-icons';
import { IRootSlice } from '@typings/rootSlice';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

const HeaderMobileLogin: React.FC = () => {
    const { namespace } = useParams();
    const dispatch = useAppDispatch();
    const rightMenuOpen = useAppSelector((state: IRootSlice) => state.globalSlice.rightMenuOpen);
    const { data: namespaceData } = useGetNamespaceQuery(namespace, {
        skip: !namespace,
    });
    const documentTitle = namespaceData?.title || 'Справка';

    const checkView = () => {
        if (window.matchMedia('(max-width: 1200px)').matches) {
            dispatch(setRightMenuOpen(false));
        } else {
            dispatch(setRightMenuOpen(false));
        }
    };

    useEffect(() => {
        checkView();

        let timer = null;
        const handleResize = () => {
            clearTimeout(timer);
            timer = setTimeout(() => checkView(), 300);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onToggleBurger = () => {
        dispatch(setRightMenuOpen(!rightMenuOpen));
    };

    return (
        <div className="header-mobile">
            <div className="header-mobile__block">
                <div className='header-mobile__close' onClick={onToggleBurger}><IconMobMenuBurgerClose24 color='#fff' /></div>
                <div className="header-mobile__menu">
                    <Link to='/help' className={`header-mobile__item ${documentTitle === 'Правовые документы' ? '' : 'active'}`}>Справка</Link>
                    <Link to='/legal' className={`header-mobile__item ${documentTitle === 'Правовые документы' ? 'active' : ''}`}>Правовые документы</Link>
                </div>
            </div>
            <a
                href="/td"
                 className="header-mobile__auth"
            >
                Войти
            </a>
        </div>
    );
};

export default HeaderMobileLogin;
